import { styled, css } from 'styled-components';
export const IconContainer = styled.div `
  position: absolute;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  right: 0;
  top: 0;
  bottom: 0;
  width: 36px;
  z-index: ${({ $inputDisabled, $isActionIcon }) => (!$inputDisabled && $isActionIcon ? 1 : -1)};
  ${({ $isActionIcon }) => $isActionIcon &&
    css `
      cursor: pointer;
    `}
`;
export const MaxLengthContainer = styled.div `
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.grey70_1};
  background: ${({ theme }) => theme.colors.grey01_1};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  height: 36px;
  border-width: 0 0 0 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.grey30_1};
`;
export const InputWrapper = styled.div `
  position: relative;
  width: 100%;
  z-index: 1;
`;
